<template>
  <div
    class="zj-layout-main-content bgcolor scrollable"
    style="overflow: auto;"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">SOS设备详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <el-form-item
        label="设备名称"
        prop="equipmentName"
        style="display: inline-block;"
      >
        <el-input
          v-model="form.equipmentName"
          style="width:50rem;"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="设备编号"
        prop="equipmentNo"
        style="display: inline-block;"
      >
        <el-input
          v-model="form.equipmentNo"
          style="width:50rem;"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>

      <el-form-item label="区域" prop="areaCode">
        <treeselect
          v-model="form.areaCode"
          :options="RegionData"
          :disabled="!IsEdit"
          style="width:50rem;"
          noResultsText="暂无选择项"
          placeholder="请选择区域"
        />
      </el-form-item>
      <el-form-item label="附近设备" prop="equipmentNear" style="display: inline-block;">
        <el-input
          type="text"
          style="width:50rem;"
          v-model="form.equipmentNear"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item label="IP地址" prop="equipmentIp" style="display:inline-block;">
        <el-input
          style="width:50rem;"
          v-model="form.equipmentIp"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item label="端口号" prop="equipmentPort" style="display:inline-block;">
        <el-input
          style="width:50rem;"
          v-model="form.equipmentPort"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item label="通道号" prop="channelNo" style="display:inline-block;">
        <el-input
          style="width:50rem;"
          v-model="form.channelNo"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="用户名"
        prop="userName"
        style="display:inline-block;"
      >
        <el-input
          style="width:50rem;"
          v-model="form.userName"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="userPw" style="display:inline-block;">
        <el-input
          style="width:50rem;"
          v-model="form.userPw"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item label="经度" prop="latitude" style="display:inline-block;">
        <el-input
          style="width:50rem;"
          v-model="form.latitude"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>
      <el-form-item label="纬度" prop="longitude" style="display:inline-block;">
        <el-input
          style="width:45rem;"
          v-model="form.longitude"
          v-bind:disabled="!IsEdit"
        ></el-input>
        <!-- <el-button
          @click="getCurrentPostion()"
          style="width:8rem;"
          v-bind:disabled="!IsEdit"
          >定位</el-button
        > -->
        <ZjLngLatSelect
          :point_lat="form.latitude"
          :point_lng="form.longitude"
          style="margin-left:0.5rem"
          @onGotLngLat="onGotLngLat"
        ></ZjLngLatSelect>
      </el-form-item>
      <el-form-item
        label="RTSP"
        prop="streamUrl"
        style="display:inline-block;"
      >
        <el-input
          style="width:50rem;"
          v-model="form.streamUrl"
          v-bind:disabled="!IsEdit"
          value='1111'
        ></el-input>
      </el-form-item>
      <el-form-item
        label="密度间值"
        prop="extra2"
        style="display:inline-block;"
      >
        <el-input
          style="width:50rem;"
          v-model="form.extra2"
          v-bind:disabled="!IsEdit"
        ></el-input>
      </el-form-item>

      <el-form-item class="right" style="width:134rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="submitForm()"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
    
  </div>
</template>
<script>
import { addEquipment, getEquipmentById, updateEquipment } from "@/api/src/equipment";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "envdetectEquipmentInfo",
  controller: "UI",
  action: "envdetectEquipmentInfo",
  components: {
    Treeselect
  },
  data() {
    return {
      form: {
        equipmentName: null,
        equipmentNo: null,
        categoryCode: null,
        areaCode: null,
        equipmentNear: null,
        equipmentIp: null,
        equipmentPort: null,
        channelNo: null,
        userName:null,
        userPw:null,
        longitude: null,
        latitude: null,
        streamUrl:null,
        extra2: null,
      },
      rules: {
        equipmentName: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
        ],
        categoryCode: [
          { required: true, message: "请选择设备类型", trigger: "change" },
        ],
        areaCode: [
          { required: true, message: "请选择区域", trigger: "change" },
        ],
      },
      IsEdit: false,
      // 区域数据
      RegionData: [],
    };
  },
  created: function() {
    if(this.$route.query.areaTree){
      this.RegionData = this.$route.query.areaTree
    }
    if (this.$route.query.id) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  // mounted: function() {},
  // watch: {
  //   $route: function() {
  //     if (this.$route.query.id) {
  //       this.search();
  //     }
  //   },
  // },
  methods: {
    search() {
      getEquipmentById(this.$route.query.id).then(response => {
        const data = response.data;
        this.form = Object.assign({},this.form,data);
      });
    },
    onGotLngLat(obj) {
      this.form.latitude = obj.lat;
      this.form.longitude = obj.lng;
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    submitForm() {
      this.$refs["form"].validate(valid => {
      if (valid) {
        if (this.$route.query.id) {
          updateEquipment(this.form).then(response => {
            this.$message({type: "success", message: "修改成功"});
            this.$router.go(-1);
          });
        } else {
          this.form.categoryCode = this.$route.query.categoryCode;
          this.form.onlineStatus = '1';
          addEquipment(this.form).then(response => {
            this.$message({type: "success", message: "新增成功"});
            this.$router.go(-1);
          });
        }
      }
    });
  },
  },
 
};
</script>
<style scoped>
::v-deep .vue-treeselect__control{
  height: 4rem;
}
::v-deep .vue-treeselect__placeholder, 
::v-deep .vue-treeselect__single-value{
  line-height: unset;
}
::v-deep .vue-treeselect__control,
::v-deep .vue-treeselect--open-below,
::v-deep .vue-treeselect__menu{
  border-radius: 0;
}
</style>